(function documentRRHHModuleDefinition() {
    'use strict';

    angular.module('DocumentRRHH', ['ui.router', 'Config', 'Entities', 'CustomControls', 'FileDownloader', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator', 'DocumentViewer'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function documentRRHHConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('document-rrhh-add', {
                    url: '/DocumentRRHH/Add',
                    params: { employeeFiles: [], headers: [] },
                    templateUrl: config.resourceUrl('/views/document-rrhh/document-rrhh-add.html'),
                    controller: 'DocumentRRHHAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT WRITE')
                });

                $stateProvider.state('document-rrhh-find', {
                    url: "/DocumentRRHH/Find",
                    templateUrl: config.resourceUrl('/views/document-rrhh/document-rrhh-find.html'),
                    controller: 'DocumentRRHHFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT READ')
                });

                $stateProvider.state('document-rrhh-sign', {
                    url: "/DocumentRRHH/Sign",
                    templateUrl: config.resourceUrl('/views/document-rrhh/document-rrhh-sign.html'),
                    controller: 'DocumentRRHHSignController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT READ').and('DOCUMENT MULTIPLE SIGN')
                });

                $stateProvider.state('document-rrhh-detail', {
                    url: "/DocumentRRHH/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/document-rrhh/document-rrhh-detail.html'),
                    controller: 'DocumentRRHHDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT READ').or('DOCUMENT WRITE')
                });
            }
        ]);
})();
